import { Component, OnInit, Inject } from '@angular/core';
import { FornecedorEstruturaItem } from 'src/app/models/fornecedor-estrutura-item';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { FornecedorEstruturaItemService } from 'src/app/services/fornecedor-estrutura-item.service';
import { Variavel } from 'src/app/models/variavel';
import insertTextAtCursor from 'insert-text-at-cursor';
import { FornecedorEstruturaService } from 'src/app/services/fornecedor-estrutura.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HighlightTag } from 'angular-text-input-highlight';
import { InfoRegrasEstruturaModalComponent } from '../info-regras-estrutura-modal/info-regras-estrutura-modal.component';
import { ProdutosModalComponent } from '../produtos-modal/produtos-modal.component';
import { ItemPedido } from 'src/app/models/pedido';
import { ItemFormulaGeral } from 'src/app/models/item-formula-geral';
import { ItemFormulaGeralService } from 'src/app/services/item-formula-geral.service';
import { ProdutosV2ModalComponent } from "../produtos-v2-modal/produtos-v2-modal.component";
import { TipoFiltroProduto } from "../../models/enum";
import { PremissasSistema } from "../../models/premissas-sistema";
import { PremissasService } from "../../services/premissas.service";

// jquery
declare const $: any;

@Component({
  selector: 'app-formula-item-estrutura-modal',
  templateUrl: './formula-item-estrutura-modal.component.html',
  styleUrls: ['./formula-item-estrutura-modal.component.scss']
})
export class FormulaItemEstruturaModalComponent implements OnInit {
  item: any;

  autorModal = 0; // 0 - assunto | 1 - texto
  variavelSelecionada: Variavel;
  variaveis: Variavel[] = [];

  grupos: string[] = [];

  tags: HighlightTag[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  formulaGeral = false;

  premissasSistema: PremissasSistema = new PremissasSistema();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private dialogRef: MatDialogRef<FormulaItemEstruturaModalComponent>,
    private fornecedorEstruturaItemService: FornecedorEstruturaItemService,
    private fornecedorEstruturaService: FornecedorEstruturaService,
    private itemFormulaGeralService: ItemFormulaGeralService,
    private premissasService: PremissasService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.buscarPremissasSistema();

    if(this.data.formulaGeral) {
      this.formulaGeral = true;
      this.item = this.data.itemFormulaGeral ? Object.assign(new ItemFormulaGeral(), this.data.itemFormulaGeral) : new ItemFormulaGeral();
    } else {
      this.item = this.data.item ? Object.assign(new FornecedorEstruturaItem(), this.data.item) : new FornecedorEstruturaItem();
    }

    this.buscarVariaveis();

    // this.addTags();

    this.dialogRef.disableClose = true;
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      async (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  // addTags() {
  //   this.tags = [];
  //   const matchMentions = /(@\w+) ?/g;
  //   let mention;
  //   // tslint:disable-next-line
  //   while ((mention = matchMentions.exec(this.item.formulaQtd))) {
  //     this.tags.push({
  //       indices: {
  //         start: mention.index,
  //         end: mention.index + mention[1].length
  //       },
  //       data: mention[1]
  //     });
  //   }

  //   const matchHashtags = /(#\w+) ?/g;
  //   let hashtag;
  //   // tslint:disable-next-line
  //   while ((hashtag = matchHashtags.exec(this.item.formulaQtd))) {
  //     this.tags.push({
  //       indices: {
  //         start: hashtag.index,
  //         end: hashtag.index + hashtag[1].length
  //       },
  //       cssClass: 'bg-pink',
  //       data: hashtag[1]
  //     });
  //   }

  //   console.table(this.tags);
  // }



  filtrarVariaveis(grupo) {
    return this.variaveis.filter(p => p.grupo === grupo);
  }

  selecionarVariavel(variavel: Variavel) {
    this.variavelSelecionada = variavel;
    $('#modalVariaveis').modal('hide');
  }

  buscarVariaveis() {
    this.carregandoService.mostra('buscarVariaveis');

    this.fornecedorEstruturaService.consultarVariaveis(this.formulaGeral).subscribe(
      (vars) => {
        this.variaveis = vars;
        this.grupos = [...new Set(this.variaveis.map(p => p.grupo))];

        this.carregandoService.esconde('buscarVariaveis');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVariaveis');
        this.notificacaoService.erro(erro);
      }
    );
  }

  mostrarVariaveis() {
    this.autorModal = 0;
    this.variavelSelecionada = undefined;
    $('#modalVariaveis').modal({});

    $('#modalVariaveis').on('hidden.bs.modal', (e) => {

      if (this.variavelSelecionada && this.autorModal == 0) {
        const el = document.getElementById('formula');
        insertTextAtCursor(el, this.variavelSelecionada.texto);
      }
      $('#modalVariaveis').off('hidden.bs.modal');
    });
  }

  salvar() {
    if (this.item instanceof FornecedorEstruturaItem) {
      this.carregandoService.mostra('salvar');

      this.fornecedorEstruturaItemService.salvar(this.item).subscribe(
        () => {
          this.carregandoService.esconde('salvar');
          this.notificacaoService.sucesso('Item salvo com sucesso!!!')
          this.dialogRef.close(true);
        },
        err => {
          this.carregandoService.esconde('salvar');
          this.notificacaoService.erro(err);
        }
      )
    } else if (this.item instanceof ItemFormulaGeral) {
      this.carregandoService.mostra('salvar');

      this.itemFormulaGeralService.salvar(this.item).subscribe(
        () => {
          this.carregandoService.esconde('salvar');
          this.notificacaoService.sucesso('Fórmula salva com sucesso!!!')
          this.dialogRef.close(true);
        },
        err => {
          this.carregandoService.esconde('salvar');
          this.notificacaoService.erro(err);
        }
      )
    }
  }

  abrirModalInfo() {
    const largura = Number($('body').width());
    this.dialog.open(InfoRegrasEstruturaModalComponent, {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card',
    });
  }

  pesquisarProduto() {
    let dialogRef;
    const config = {
      width: ($('body').width()).toString() + 'px',
      data: {
        somenteEstrutura: !this.formulaGeral,
        produtos: [],
        selecionaSomenteUm: true,
        situacao: 'T'
      },
      panelClass: 'modal-card',
      // maxHeight: '90vh'
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(ProdutosModalComponent, config);
    } else {
      dialogRef = this.dialog.open(ProdutosV2ModalComponent, config);
    }

    dialogRef.afterClosed().subscribe((result: ItemPedido[]) => {
      if (result) {
        const produtoSelecionado = result[0];
        this.item.idProduto = produtoSelecionado.produtoTela.idProduto;
        this.item.produto = produtoSelecionado.produtoTela.descricao;
      }
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
